(function() {
  'use strict';

  angular.module('component.todos', []);
})();
